import './common/polyfill';
import 'wicg-inert';
import objectFitImages from 'object-fit-images';

import initCookieConsent from './components/cookie-consent';
import initHeader from './common/header';
import initFooter from './common/footer';
import initSinglePolitiker from './layout/single-politiker';
import initVideoPreview from './components/video-preview';
import initFeaturedBlocks from './blocks/featured-topics';
import initSendlistBlock from './blocks/sendlist';
import initPoliticsIndexBlock from './blocks/politics-index';
import initLocalSiteListBlock from './blocks/local-site-list';
import initSocialFeedBlock from './blocks/feed-social';
import initPoliticiansBlock from './blocks/politicians';
import initArticles from './layout/articles';
import initOldSections from './layout/old-sections';
import initAccessibility from './common/accessibility';
import initPageHeaders from './blocks/page-header';
import initChat from './components/chat';
import { initIntroEuBlock } from './blocks/intro-eu';
import { initEuCampaign } from './layout/eu-campaign';

jQuery(() => {
    initHeader();
    initFooter();
    initCookieConsent();

    initSinglePolitiker();
    initArticles();
    initOldSections();

    initPageHeaders();
    initVideoPreview();
    initFeaturedBlocks();
    initSendlistBlock();
    initPoliticsIndexBlock();
    initLocalSiteListBlock();
    initSocialFeedBlock();
    initPoliticiansBlock();
    initAccessibility();

    initIntroEuBlock();
    initEuCampaign();

    initObfEmails();
    initScrollToTop();

    initChat();

    window.addEventListener('load', () => objectFitImages(), { once: true });
});


function initScrollToTop() {
    const topScroller = document.getElementById('scrollToTop');
    topScroller.addEventListener('click', event => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    });
    ;['load', 'resize', 'orientationchange', 'scroll'].forEach(eventName => {
        window.addEventListener(eventName, () => {
            window.scrollY > window.innerHeight
            ? topScroller.classList.remove('is--hidden')
            : topScroller.classList.add('is--hidden');
        }, { passive: true });
    });
}

function initObfEmails() {
    [].slice.apply(document.querySelectorAll('[data-obf-mailto]')).forEach(a => {
        const email = atob(a.dataset.obfMailto);
        a.addEventListener('click', event => {
            event.isTrusted && (a.href = `mailto:${email}`);
        }, {
            capture: true,
            once: true,
        });
    });
    setTimeout(() => {
        [].slice.apply(document.querySelectorAll('[data-obf-email]')).forEach(el => {
            const email = atob(el.dataset.obfEmail);
            el.parentElement.replaceChild(document.createTextNode(email), el);
        });
    }, 50);
}
